/* eslint no-param-reassign: 0 */

const mutations = {
  SET_LAST_CLOSED(state, timestamp) {
    state.lastClosedAt = timestamp;
    localStorage.setItem('modalLastClosedAt', timestamp);
  },
};

export default mutations;
